module.exports = __webpack_public_path__ + "static/img/commend1.f7ea177.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/commend1.jpg
// module id = VTda
// module chunks = 1